module.exports = __webpack_public_path__ + "img/USDT-ERC20.4701ca22.png";